import { CalculsFormNewPerteGainsProfessionnelsActuels } from '@norma/shared/constants/calculs';
import { NewPrejudiceFormPerteGainProfessionnelsActuel } from '@norma/shared/types/prejudice.type';
import { Procedure } from '@norma/shared/types/procedure.type';
import { pick } from 'lodash';
import React from 'react';
import { Control } from 'react-hook-form';
import { ComputedPropsForm } from '../../../forms/ComputedPropsForm';
import { TotalIndemniteGlobaleARepartirEchus } from '../TotalIndemniteGlobaleARepartirEchus';

interface Props {
  control: Control<NewPrejudiceFormPerteGainProfessionnelsActuel>;
  procedure: Procedure;
}

export const TotalNewPerteGainsActuels: React.FC<Props> = ({
  control,
  procedure,
}) => {
  return (
    <ComputedPropsForm
      control={control}
      watchFields={[
        'perteDeGainsProfessionnels.total',
        'indemnitesJournalieresPercuesPendantLaPeriodeDArret.csgRdsTotal',
        'indemnitesJournalieresPercuesPendantLaPeriodeDArret.indemnitesJournalieresPercuesNet',
        'indemnitesJournalieresPercuesPendantLaPeriodeDArret.rows',
      ]}
      compute={([
        perteGainProfessionnelsTotal,
        indemnitesJournalieresPercuesPendantLaPeriodeDArretCsgRdsTotal,
        indemnitesJournalieresPercuesPendantLaPeriodeDArretIndemnitesJournalieresPercuesNet,
        indemnitesJournalieresPercuesPendantLaPeriodeDArretRows,
      ]) => {
        return {
          props: {
            ...CalculsFormNewPerteGainsProfessionnelsActuels.getIndemnitesRepartie(
              {
                perteGainProfessionnelsTotal,
                indemnitesJournalieresPercuesPendantLaPeriodeDArretCsgRdsTotal,
                indemnitesJournalieresPercuesPendantLaPeriodeDArretIndemnitesJournalieresPercuesNet,
                indemnitesJournalieresPercuesPendantLaPeriodeDArretRows,
                partResponsabilite: procedure.partResponsabilite,
              },
            ),
          },
        };
      }}
      render={(untypedIndemniteGlobaleARepartir) => {
        const indemniteGlobaleARepartir =
          untypedIndemniteGlobaleARepartir as ReturnType<
            typeof CalculsFormNewPerteGainsProfessionnelsActuels.getIndemnitesRepartie
          >;
        return (
          <TotalIndemniteGlobaleARepartirEchus
            indemniteGlobaleARepartir={indemniteGlobaleARepartir}
            tropPercu={pick(indemniteGlobaleARepartir, 'tropPercu')}
            partResponsabilite={procedure.partResponsabilite}
          />
        );
      }}
    />
  );
};
